import { ISocialNetworkRepository } from '../../../domain/repositories/social-network.repository.interface';
import { SocialNetwork } from '../../../domain/entities/social-network.entity';

export class ChangeSocialNetworkStatusUseCase {
  constructor(private readonly repository: ISocialNetworkRepository) {}

  public async execute(id: string, isActive: boolean): Promise<SocialNetwork> {
    return this.repository.changeStatus(id, isActive);
  }
}
